var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('div',{staticClass:"SubMenuWrapper"},[_c('SubMenuBarM3')],1),_c('div',{staticClass:"PageContentsWrapper"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }